import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { logout } from "./../../actions/auth";
import { connect } from 'react-redux';
import Container from '@mui/material/Container';
import Drawer from '@mui/material/Drawer';
import { FaBars, FaTimes } from "react-icons/fa"; // Importamos íconos de React Icons
import logo from '../../../static/frontend/assets/images/logo_circular.png';
import icon from '../../../static/frontend/assets/images/home-icon.svg';
import { useTheme, useMediaQuery } from '@mui/material';

const Header = ({ user, logout }) => {
    const location = useLocation();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg')); // Detecta si la pantalla es menor a 1024px

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    if (location.pathname.startsWith("/panel") || location.pathname.startsWith("/pdf-builder")) {
        return null;
    }
    // Menú para usuarios autenticados
    const userLinks = (
        <ul className="panel-top">
            <li className="nav-item">
                <NavLink to="/" className="nav-link"><img className="icon-home" src={`${icon}`} alt="Home" /></NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/explorar">Explorar</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/especies">Especies</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/paquete">Paquetes</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/proyectos">Proyectos</NavLink>
            </li>
            {/* <li className="nav-item">
                <NavLink className="nav-link" to="/dex">Dex</NavLink>
            </li> */}
            <li className="nav-item">
                <NavLink className="nav-link" to="/panel">Panel</NavLink>
            </li>
            {/* <li className="nav-item">
                <NavLink className="nav-link" to="/usuario">Perfil</NavLink>
            </li> */}
            <li className="nav-item">
                <NavLink className="nav-link" to="/" onClick={logout}>Cerrar Sesión</NavLink>
            </li>
        </ul>
    );

    // Menú para invitados
    const guestLinks = (
        <ul className="panel-top">
            <li className="nav-item">
                <NavLink to="/" className="nav-link"><img className="icon-home" src={`${icon}`} alt="Home" /></NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/explorar">Explorar</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/especies">Especies</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/paquete">Paquetes</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/proyectos">Proyectos</NavLink>
            </li>
            {/* <li className="nav-item">
                <NavLink className="nav-link" to="/dex">Dex</NavLink>
            </li> */}
            <li className="nav-item">
                <NavLink className="nav-link" to="/login">Iniciar Sesión</NavLink>
            </li>
        </ul>
    );

    return (
        <header className="header">
            <Container maxWidth="xl">
                <nav className="nav-general">
                    <div className="logo-zone">
                        <a className={user.isAuthenticated ? "navbar-brand naturaldex-top-logeado" : "navbar-brand naturaldex-top"} href="/">
                            <img className="image-logo-p" src={`${logo}`} alt="Logo" />
                        </a>
                    </div>

                    {/* Menú normal para pantallas grandes */}
                    {!isMobile && (user.isAuthenticated ? userLinks : guestLinks)}

                    {/* Menú responsive para pantallas pequeñas */}
                    {isMobile && (
                        <>
                            <button className="menu-button" onClick={toggleDrawer(true)} aria-label="Abrir menú">
                                <FaBars size={24} /> {/* Ícono de hamburguesa */}
                            </button>
                            <Drawer
                                anchor="right"
                                open={drawerOpen}
                                onClose={toggleDrawer(false)}
                                PaperProps={{ style: { width: '250px' } }} // Ancho del Drawer
                            >
                                <div className="drawer-content">
                                    <button className="close-button" onClick={toggleDrawer(false)} aria-label="Cerrar menú">
                                        <FaTimes size={24} /> {/* Ícono de cierre */}
                                    </button>
                                    {user.isAuthenticated ? userLinks : guestLinks}
                                </div>
                            </Drawer>
                        </>
                    )}
                </nav>
            </Container>
        </header>
    );
};

const mapStateToProps = reducer => ({
    user: reducer.user
});

export default connect(
    mapStateToProps,
    { logout }
)(Header);